/**
 * Stores all resources currently used
 */
export const Globals = {
    resources: {}
};